<script>
import resources from './resources'

export default {
  name: 'agenda-form',
  mixins: [resources]
}
</script>

<template lang="pug">
  #starAgendaForm.col-xs-12.col-sm-10.col-sm-offset-1
    div(v-if="reserving")
      div.text-center
        i.fa.fa-circle-o-notch.fa-spin.fa-4x.fa-fw(style="color: #2071b9")
        span.sr-only(style="color: #2071b9")
         |aguarde
    div(v-if="!reserving")
      h3 CONFIRME O AGENDAMENTO DA CONSULTA
        countdown(:date="countdown", @timeout="doClose")
      .row.border-bottom
        .col-xs-12.col-sm-5.margin-bottom
          small Dia
          br
          span.blue
            i.fa.fa-calendar
            |  {{ getDay }}
        .col-xs-12.col-sm-4.margin-bottom
          small.grey Hora
          br
          span.blue
            span
              i.fa.fa-clock-o
              |  {{ time.time.slice(0, 5) }}
        .col-xs-12.col-sm-3.margin-bottom
          small.grey Preço Particular
          br
          span.blue
            div(v-if="agenda._parsed.price_real > 0")
              span.rs R$
              span.valor {{ agenda._parsed.price_real }}
              span.cents ,{{ agenda._parsed.price_cents }}
              span.cents(v-if="!agenda._parsed.price_cents")
                | 00

            div(v-if="agenda._parsed.price_real <= 0")
              span.rs Não informado

      .row.border-bottom
        .col-xs-12.col-sm-6.margin-bottom
          small.grey Nome do Profissional
          br
          span.blue {{ agenda.professional_name }}
          small.grey Especialidade
          br
          div.especialidade {{ agenda.speciality }}
          div.endereco
            | {{ agenda.street }}, {{ agenda.number}}
            br
            | {{ agenda.zip }} - {{ agenda.district}} - {{ agenda.city }} - {{ agenda.state}}

          small.grey Convênios
          div
            .planos(v-if="agenda.covenant")
              span(v-for="covenants in agenda.covenant.split(',')" :tag="covenants")
                | {{ covenants }}
            .planos(v-if="!agenda.covenant")
              span
                | Somente Particular

        .col-xs-12.col-sm-6.margin-bottom
          f-select-patient(
            label="Paciente",
            v-model="patient.id",
            :get-all="true",
            :searchable="false",
            @selected="onSelectedPatient"
            )

        .col-xs-12.col-sm-6.margin-bottom(v-if="covenants.length > 0")
          f-select(
            label="Selecione Convênio ou particular ",
            v-model="agenda.covenant_id",
            :options="covenants",
            @selected="verifyPrivate"
            :searchable="false",
            label-by="name"
            )
          p.help-block.danger(v-if="activeMsgSelectCovenant")
              strong
                | Favor selecionar uma opção para agendar sua consulta.
          p.help-block.danger(v-if="doesNotAttend")
              strong
                | Este profissional não atende ao convênio selecionado.  &nbsp;
                | Selecione a opção
                | particular
                | para confirmar sua consulta.
        .col-xs-12.col-sm-6.margin-bottom(v-if="covenants.length == 0")
          f-select(
            label="Selecione Convênio ou particular",
            v-model="agenda.covenant_id",
            :options="optionPrivate",
            :searchable="false",
            @selected="verifyPrivate",
            label-by="name"
            )
          p.help-block.danger(v-if="activeMsgSelectCovenant")
            strong
              | Você não possui nenhum convênio cadastrado. Favor selecionar  Particular  para agendar sua consulta.

      //- alert-shedule(v-if="covenants.length == 0")
      //- alert-covenant-not-exist(v-if="alertCovenantNotExist && covenants.length > 0")
      .buttons-wrapper
        button.btn.cancel(@click.prevent="doClose()")
          span.icon 
          |  Cancelar
        button.btn.save-filled(@click.prevent="doSave()", v-if="!activeSchedules && !schedulingProcessing")
          .icon(v-if="schedulingProcessing") 
          span(v-if="!schedulingProcessing") Agendar Consulta

        button.btn.save-filled(v-if="schedulingProcessing")
          span.icon(v-if="schedulingProcessing")
          i.fa.fa-circle-o-notch.fa-spin(v-if="schedulingProcessing",style='font-size:16px') &nbsp;
          span(v-if="schedulingProcessing") Aguarde processando

        button.btn.save-filled(disabled, v-if="activeSchedules")
          span.icon 
          |  Agendar Consulta

</template>
<style scoped>
  .danger {
      color: #a94442;
  }
</style>



// WEBPACK FOOTER //
// src/app/patient/agendas/form/form.vue